import TypesetStyle from './TypesetStyle';

export default TypesetStyle;
